import React from 'react';

type PageLoadFallbackProps = {
  pathname?: string;
};

function titleForPath(pathname = '/'): string {
  if (pathname.startsWith('/portal')) return 'Loading your agentOmatic portal';
  if (pathname.startsWith('/install')) return 'Loading install commands';
  if (pathname.startsWith('/success')) return 'Preparing your next step';
  if (pathname.startsWith('/landing') || pathname === '/' || pathname.startsWith('/x') || pathname.startsWith('/youtube')) {
    return 'Loading agentOmatic';
  }
  return 'Loading agentOmatic';
}

const PageLoadFallback: React.FC<PageLoadFallbackProps> = ({ pathname }) => (
  <main
    aria-label="Loading agentOmatic"
    style={{
      minHeight: '100vh',
      display: 'grid',
      placeItems: 'center',
      padding: '40px 20px',
      color: '#f8fafc',
      background:
        'radial-gradient(circle at 20% 10%, rgba(45,212,191,0.18), transparent 30%), radial-gradient(circle at 80% 0%, rgba(192,132,252,0.14), transparent 28%), linear-gradient(135deg, #05050a 0%, #0b1020 52%, #030712 100%)',
    }}
  >
    <section
      style={{
        width: 'min(720px, 100%)',
        textAlign: 'center',
        border: '1px solid rgba(45,212,191,0.20)',
        borderRadius: 28,
        padding: '34px 28px',
        background: 'rgba(2,6,23,0.54)',
        boxShadow: '0 28px 90px rgba(0,0,0,0.38)',
      }}
    >
      <img
        src="/brand/agentomatic-chrome-wordmark-640.webp"
        alt="agentOmatic"
        width={640}
        height={167}
        style={{ width: 'min(280px, 72vw)', height: 'auto', display: 'block', margin: '0 auto 14px' }}
      />
      <p style={{ margin: 0, color: '#cbd5e1', fontSize: 16, fontWeight: 800, letterSpacing: '0.01em' }}>
        {titleForPath(pathname)}
      </p>
      <div
        aria-hidden="true"
        style={{
          width: 180,
          height: 4,
          margin: '22px auto 0',
          borderRadius: 999,
          overflow: 'hidden',
          background: 'rgba(148,163,184,0.18)',
        }}
      >
        <div
          style={{
            width: '42%',
            height: '100%',
            borderRadius: 999,
            background: 'linear-gradient(90deg, #2dd4bf, #7c6cf0)',
            boxShadow: '0 0 24px rgba(45,212,191,0.5)',
          }}
        />
      </div>
    </section>
  </main>
);

export default PageLoadFallback;
